/**
 * The key LaunchDarkly evaluates a signed-in user's flags for: their login email. The Propstack embed's
 * broker session has no Auth0 user, so it falls back to the email of the platform profile; without it
 * every embed session evaluated as anonymous and per-user targets never applied there.
 */
export const flagUserId = (isAuthenticated: boolean, auth0Email?: string, platformEmail?: string): string | undefined =>
  isAuthenticated ? (auth0Email ?? platformEmail) : undefined
